import BaseDialog from "@/components/BaseDialog";

// 指派管理-指派任务
export function withOncedrawModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./withdrawModal.vue'),
        options: {
            width: '800px',
            title: '指派任务',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 指派管理-批量指派
export function settleModel({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./settleModel.vue'),
        options: {
            width: '800px',
            title: '批量指派',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}


